<!--
 * @Descripttion:
 * @Author: zenghua.wang
 * @Date: 2021-09-02 15:36:47
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-09-06 13:47:27
-->
<template>
  <div>
    <el-button
      size="small"
      type="primary"
      @click="addDic(null)"
    >新增字典</el-button>
    <el-tree
      style="margin-top:20px;"
      class="xa-tree"
      :data="dicData"
      default-expand-all
      node-key="id"
      empty-text="暂无字典数据"
      ref="cascaderTree"
    >
      <div
        class="xa-tree-item"
        slot-scope="{ node, data }"
      >
        <div class="xa-tree-item__content">
          {{ node.label }}
        </div>
        <div class="xa-tree-item__action">
          <el-button
            size="small"
            type="text"
            @click.stop="addDic(data)"
          >添加</el-button>
          <el-button
            size="small"
            type="text"
            @click.stop="editDic(data)"
          >编辑</el-button>
          <el-button
            size="small"
            type="text"
            @click.stop="deleteDic(data)"
          >删除</el-button>
        </div>
      </div>
    </el-tree>

    <!--级联弹窗 -->
    <el-dialog
      :title="cascader.title"
      :visible.sync="cascader.show"
      append-to-body
      width="50%"
    >
      <el-form
        size="small"
        label-width="120px"
        label-position="left"
        label-suffix=":"
        :model="cascader.form"
        :rules="cascader.rules"
        ref="cascaderForm"
        style="padding: 0 20px"
      >
        <el-form-item
          label="label"
          prop="label"
        >
          <el-input
            v-model="cascader.form.label"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item
          label="value"
          prop="value"
        >
          <el-input
            v-model="cascader.form.value"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button
          @click="cascader.show = false"
          size="small"
        >取 消</el-button>
        <el-button
          type="primary"
          size="small"
          @click="saveDic"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { createId, isEmpty, getParentByPid } from '@/dragComponents/utils'

export default {
  name: 'dictory-cascader',
  components: {},
  props: ['dicData', 'change'],
  data() {
    return {
      cascader: {
        title: '字典',
        show: false,
        act: 'add',
        parent: null,
        form: {},
        rules: {
          label: [{ required: true, message: '请输入', trigger: 'blur' }],
          value: [{ required: true, message: '请输入', trigger: 'blur' }]
        }
      }
    }
  },
  methods: {
    // 新增字典
    addDic(data) {
      this.cascader.parent = isEmpty(data) ? null : data
      this.cascader.form = {
        id: createId(),
        pid: isEmpty(data) ? 0 : data.id
      }
      this.cascader.title = '新增字典'
      this.cascader.act = 'add'
      this.cascader.show = true
    },
    // 编辑字典
    editDic(data) {
      if (!isEmpty(data) && data.pid !== 0) {
        this.cascader.parent = getParentByPid(this.dicData, data.pid)
      } else {
        this.cascader.parent = null
      }
      this.cascader.form = data
      this.cascader.act = 'edit'
      this.cascader.title = '编辑字典'
      this.cascader.show = true
    },
    // 保存字典
    saveDic() {
      this.$refs.cascaderForm.validate((valid) => {
        if (valid) {
          if (
            isEmpty(this.cascader.form.label) &&
            isEmpty(this.cascader.form.value)
          ) {
            this.$message.error('字典的label、value 必须填写！')
            return
          }
          let parent = this.cascader.parent
          let item = this.cascader.form
          if (this.cascader.act === 'add') {
            this.$refs.cascaderTree.append(item, parent)
          }
          this.cascader.show = false
        } else {
          return false
        }
      })
    },
    // 删除级联字典
    deleteDic(data) {
      this.$refs.cascaderTree.remove(data)
    },
    // 更新下拉字典
    updateDic() {
      this.$emit('change', this.dicData)
    }
  }
}
</script>
